'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

// Interactive part of the 404 page, split out so `not-found.tsx` can stay a
// server component and export its own <title> (audit T3).
const NotFoundActions = () => {
  const router = useRouter();

  const handleGoHome = () => {
    router?.push('/');
  };

  const handleGoBack = () => {
    if (typeof window !== 'undefined') {
      window.history?.back();
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-center">
      <button
        onClick={handleGoBack}
        className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-cta font-semibold hover:bg-primary/90 transition-colors duration-200"
      >
        <Icon name="ArrowLeftIcon" size={16} />
        Go Back
      </button>

      <button
        onClick={handleGoHome}
        className="inline-flex items-center justify-center gap-2 border border-border bg-background text-foreground px-6 py-3 rounded-lg font-cta font-semibold hover:bg-accent hover:text-accent-foreground transition-colors duration-200"
      >
        <Icon name="HomeIcon" size={16} />
        Back to Home
      </button>
    </div>
  );
};

export default NotFoundActions;
